import { render } from "./Textarea.vue?vue&type=template&id=52e4fcc5"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import exportComponent from "/home/berisalam-console/webapps/berisalam-console/releases/1793606032384/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__